import { Component, ElementRef, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NavigationEnd, Router } from '@angular/router';
import { OroService } from './oroservice';
import { CookieService } from 'ngx-cookie-service';
import { DateAdapter } from '@angular/material/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit {

  constructor(private translate: TranslateService,
            private router: Router,
            public oroservice: OroService,
            public cookieservice: CookieService,
            private elementRef: ElementRef,
            private _adapter: DateAdapter<any>) {

    const browserLang = translate.getBrowserLang();
    translate.use(browserLang.match(/de|fr/) ? browserLang : 'de');
    console.log(browserLang);
    this.cookieservice.set('lang', browserLang);
  }

  ngOnInit() {
    this.elementRef.nativeElement.removeAttribute("ng-version");

    window.addEventListener('wheel', (event) => {
      const target = event.target as HTMLInputElement;
      if (target && target.tagName.toLowerCase() === 'input' && target.getAttribute('type') === 'number') {
        event.preventDefault();
      }
    }, { passive: false });

      this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }

  SetDE(){
    this.translate.use('de');
    this.cookieservice.set('lang','de');
    this._adapter.setLocale('de-CH');
  }
  SetFR(){
    this.translate.use('fr');
    this.cookieservice.set('lang','fr');
    this._adapter.setLocale('fr-CH');
  }
  SetIT(){
    this.translate.use('it');
    this.cookieservice.set('lang','it');
    this._adapter.setLocale('it-CH');
  }

    Logout() {
        this.oroservice.setLogout();
        window.location.href ="/?Logout=1";
  }
}
